// ofuro-wiki: Telemetry disabled for self-hosted deployment
export function Telemetry() {
  return null;
}
